<template>
  <v-card
    color="card"
    class="splitted-score"
  >
    <v-row
      no-gutters
      class="score-part"
    >
      <v-col
        cols="8"
      >
        {{ $t('splitted_score.decisive') }}
      </v-col>
      <v-col
        class="score"
        :class="[decisiveScoreClass]"
      >
        {{ decisiveScore }}
      </v-col>
    </v-row>
    <v-row
      no-gutters
      class="score-part"
    >
      <v-col
        cols="8"
      >
        {{ $t('splitted_score.all_around') }}
      </v-col>
      <v-col
        class="score"
        :class="[allAroundScoreClass]"
      >
        {{ allAroundScore }}
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'SplittedScore',
  props: {
    decisiveScore: {
      type: Number,
      default: null,
    },
    allAroundScore: {
      type: Number,
      default: null,
    },
  },
  computed: {
    decisiveScoreClass() {
      if (this.decisiveScore >= 60) {
        return 'high';
      } if (this.decisiveScore === 35) {
        return 'medium';
      }

      return 'low';
    },
    allAroundScoreClass() {
      if (this.allAroundScore >= 20) {
        return 'high';
      } if (this.allAroundScore >= 0) {
        return 'medium';
      }

      return 'low';
    },
  },
};
</script>

<style scoped lang="scss">
.splitted-score {
  width: 180px;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 14px;
}

.score-part {
  margin: 10px 0;
  align-items: center;
}

.score {
  text-align: right;
  font-size: 18px;
}

.low {
  color: $error;
}

.medium {
  color: #FFA31A;
}

.high {
  color: $success;
}
</style>
